import moment, { Moment } from 'moment';
import { ReportTypes, ReportStatus } from '../../enum/CirgsReportEnums';
import CirgsReportExecutionAttributes from './CirgsReportExecutionAttributes';
import CirgsReportFile from './CirgsReportFile';

class CirgsReport {
  id?: string;

  name: string;

  type: ReportTypes;

  status: ReportStatus;

  d8TotalAmount?: number;

  d8TotalPremiumAmount?: number;

  files: CirgsReportFile[];

  createdAt?: Moment;

  completedAt?: Moment;

  updatedAt?: Moment;

  executionAttributes?: CirgsReportExecutionAttributes;

  constructor(name: string, type: ReportTypes, status: ReportStatus,
    d8TotalAmount?: number, d8TotalPremiumAmount?: number, id?: string,
    createdAt?: Moment, updatedAt?: Moment, completedAt?: Moment,
    files: CirgsReportFile[] = [],
    executionAttributes: CirgsReportExecutionAttributes = {}) {
    this.name = name;
    this.id = id;
    this.type = type;
    this.status = status;
    this.d8TotalAmount = d8TotalAmount;
    this.d8TotalPremiumAmount = d8TotalPremiumAmount;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.completedAt = completedAt;
    this.files = files;
    this.executionAttributes = executionAttributes;
  }

  public objectToBody() {
    return {
      id: this.id,
      name: this.name,
      type: this.type,
      d8TotalAmount: this.d8TotalAmount,
      d8TotalPremiumAmount: this.d8TotalPremiumAmount,
      files: this.files ? this.files.map((file) => file.objectToBody()) : [],
      executionAttributes: this.executionAttributes,
    };
  }

  public static jsonToObject(object: any): CirgsReport {
    return new CirgsReport(
      object.name,
      object.type as ReportTypes,
      object.status as ReportStatus,
      object.d8TotalAmount,
      object.d8TotalPremiumAmount,
      object.id,
      moment(object.createdAt),
      moment(object.updatedAt),
      object.completedAt ? moment(object.completedAt) : undefined,
      object.files ? object.files.map((file: any) => CirgsReportFile.jsonToObject(file)) : [],
      object.executionAttributes,
    );
  }
}

export default CirgsReport;
